<script setup lang="ts">

import { IconLogout } from "@iconify-prerendered/vue-carbon";
import MButton from "../components/buttons/MButton.vue";
import { usePersonStore } from "../store";
import { storeToRefs } from "pinia";


const personStore = usePersonStore();
const { person } = storeToRefs(personStore);
const { logout } = personStore;

</script>

<template>
  <MButton v-if="person !== null" size2="medium" kind="secondary" @click="logout">
    {{ $t("Logout") }}
    <IconLogout class="inline" />
  </MButton>
</template>

<style scoped lang="scss">

</style>
